export default "__VITE_ASSET__DNFTjwfi__"